import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import CircularProgress from '@material-ui/core/CircularProgress';
import { IconButton } from '@material-ui/core';
import React from 'react';
import WrapperWithTooltip from 'components/atoms/WrapperWithTooltip';
import useStyles from './style';

const LoadMoreCell = ({ row, isLoading, isExpanded, handleClickRow }) => {
  const classes = useStyles();

  const toggleRowExpandedProps = row.getToggleRowExpandedProps();

  const onClick = async event => {
    if (!isLoading) {
      if (!isExpanded) {
        await handleClickRow({ ...row, isExpanded });
      }
      toggleRowExpandedProps.onClick(event);
    }
  };

  const disableExpandButton = React.useMemo(
    // Se a linha for expandida e não tiver filhos o botão ficará desabilitado
    () => Boolean(row.isExpanded && !row.subRows.length),
    [row.isExpanded, row.subRows.length],
  );

  const applyButtonOpenStyles = () =>
    row.isExpanded
      ? [classes.toggleButton, classes.toggleButtonClosed].join(' ')
      : classes.toggleButton;

  if (isLoading) {
    return <CircularProgress size={25} color="inherit" />;
  }

  return (
    <WrapperWithTooltip
      condition={row.isExpanded && !row.subRows.length}
      tooltipMessage="Não possui equipamento(os) cadastrado(os)"
    >
      <IconButton
        component="span"
        className={applyButtonOpenStyles()}
        onClick={onClick}
        disabled={disableExpandButton}
      >
        <KeyboardArrowDown />
      </IconButton>
    </WrapperWithTooltip>
  );
};

export default LoadMoreCell;
